export const GET_getAreaTree = "GET_getAreaTree"
export const CLASSCODE = "CLASSCODE"
export const GET_SUBMITHOSPITAL = "GET_SUBMITHOSPITAL"
export const GET_AREAHOSPITAL = "GET_AREAHOSPITAL"
export const UPDATE_CREATEHOSINFO = "UPDATE_CREATEHOSINFO"
